import type { GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { NewsDetails } from "views";
import { slugMaker } from "utils/normalizer";
import { Formatter, TAG_TREES } from "utils";
import { is404 } from "utils/newFunction";

function NewsDetailsPage({ data }) {
  return (
    <NewsDetails
      data={data}
      type="news"
      suggestedItemsLabel={{ fa: "اخبار پیشنهادی", en: "Suggested News" }}
    />
  );
}

const generateBreadcrumb = (item, locale) =>
  locale === "fa"
    ? [
        { title: "اخبار", link: "/news" },
        { title: item?.title?.value || "جزییات خبر" },
      ]
    : [
        { title: "News", link: "/news" },
        { title: item?.title?.value || "News Details" },
      ];

export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);
  try {
    const entityId = params?.slug?.[0] || "";
    const slug = params?.slug?.[1] || "";

    if (Number.isNaN(+entityId)) {
      return {
        notFound: true,
      };
    }

    const requests = [
      apiService.getNewsList({ size: 3 }), // 0
      apiService.getNewsById(entityId, { formatter: false }), // 1
    ];

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}
    if (is404(response[1])) {
      return {
        notFound: true,
      };
    }

    const target = Formatter.formatData({ data: response[1] })?.[0];

    // index only news that have same language
    if (
      !target?.tagTrees?.find((item) =>
        [
          TAG_TREES[locale?.toUpperCase() || "FA"]?.NEWS,
          TAG_TREES[locale?.toUpperCase() || "FA"]?.GRADUATED_NEWS,
        ].includes(item?.name)
      )
    ) {
      return {
        notFound: true,
      };
    }

    const normalizedSlug =
      target?.metaTag?.slug || slugMaker(target?.title?.value);
    if (normalizedSlug && normalizedSlug !== slug) {
      return {
        redirect: {
          permanent: true,
          destination: `${
            locale === "en" ? "/en" : ""
          }/news/${entityId}/${encodeURIComponent(normalizedSlug)}`,
        },
      };
    }
    return {
      props: {
        data: {
          latestNews: response[0] || [],
          news: target || null,
          changeLanguageLink: target?.changeLanguageLink?.value || "",
          canonical: !target?.changeLanguageLink?.value,
          breadcrumb:
            target?.breadcrumb?.length > 0
              ? target?.breadcrumb
              : generateBreadcrumb(target, locale),
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default NewsDetailsPage;
